import { render, staticRenderFns } from "./yc-feed.vue?vue&type=template&id=152d71e8&scoped=true&"
import script from "./yc-feed.vue?vue&type=script&lang=js&"
export * from "./yc-feed.vue?vue&type=script&lang=js&"
import style0 from "./yc-feed.vue?vue&type=style&index=0&id=152d71e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d71e8",
  null
  
)

export default component.exports